import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AGGREGATION_REDUCER_KEY } from '../reducers/aggregation.reducer';
import { AggregationState } from '../states/aggregation.state';

const currentState = createFeatureSelector<AggregationState>(AGGREGATION_REDUCER_KEY);

export const aggregationsMap$ = createSelector(currentState, (state) => state?.aggregationsMap);

export const reconAggregationsMap$ = createSelector(currentState, (state) => state?.reconAggregationsMap);

export const getReconCardinalityCount$ = (instanceId: string, fieldId: string, parentId: string) =>
    createSelector(reconAggregationsMap$, (reconAggregationsMap) => {
        return reconAggregationsMap?.[instanceId]?.[parentId]?.[fieldId]?.cardinalityCount;
    });

export const getAggregationData$ = (instanceId: string, parentId: string, fieldId: string) =>
    createSelector(aggregationsMap$, (aggregations) => {
        return aggregations?.[instanceId]?.[parentId]?.[fieldId]?.aggregations;
    });
